// extracted by mini-css-extract-plugin
export default {"input-button-wrapper":"InputToolbar_input-button-wrapper__lW43Y"};